import {getService} from '../../../service';

const signIn = () => getService('signIn');
const request = () => getService('request');

const tokenElement = document.querySelector('input[name="_csrf_token_"]');
let defaultCsrfToken = tokenElement ? tokenElement.value : '';


export const checkFavorite = pid => {
  return request().get(`/api/favorite/checkFavorite.do?objectType=company&objectId=${pid}&timestamp=${+new Date}`).then(res => {
    if (res.responseCode === 200 && res.entity) {
      return {
        isFavorite: res.entity.check !== -1,
        fid: res.entity.check
      };
    }
  });
}

export const addFavorite = (companyId = '', token = defaultCsrfToken) => {
  return new Promise((resolve, reject) => {
    signIn()().then(() => {
      request().post(`/api/favorite/addFavorite.do?objectType=company&objectId=${companyId}&companyId=${companyId}&urlRule=D&_csrf_token_=${token}&timestamp=${+new Date}`).then(res => {
        if (res.responseCode === 200 && res.entity && res.entity.check !== -1) {
          resolve({
            success: true,
            fid: res.entity.check
          });
        }
      });
    });
  });
};

export const removeFavorite = (fid, token = defaultCsrfToken) => {
  return new Promise((resolve, reject) => {
    request().post(`/api/favorite/delFavorite.do?id=${fid}&_csrf_token_=${token}&timestamp=${+new Date}`).then(res => {
      if (res.responseCode === 200 && res.entity && res.entity.remove) {
        resolve({
          success: true
        });
      }
    });
  });
};
